import React, { createContext, useContext, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { fmtEuro } from "../lib/constants";

const CostVisibilityContext = createContext(null);
const STORAGE_KEY = "thoth_show_costs";
const MASK = "€ ****";

export function CostVisibilityProvider({ children }) {
  const { user } = useAuth();
  // L'occhio dei costi è disponibile agli Amministratori principali (e al Super Admin piattaforma).
  const canToggle = !!user?.is_superadmin || user?.role === "principal";
  const [show, setShow] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });
  // I costi sono visibili SOLO a chi può attivare l'occhio e lo ha abilitato. Per tutti gli altri restano sempre nascosti.
  const revealed = canToggle && show;
  const toggle = useCallback(() => {
    setShow((s) => {
      const n = !s;
      try { localStorage.setItem(STORAGE_KEY, n ? "1" : "0"); } catch {}
      return n;
    });
  }, []);
  const money = useCallback((v) => (revealed ? fmtEuro(v) : MASK), [revealed]);
  return (
    <CostVisibilityContext.Provider value={{ revealed, canToggle, show, toggle, money }}>
      {children}
    </CostVisibilityContext.Provider>
  );
}

export function useCostVisibility() {
  return useContext(CostVisibilityContext) || { revealed: false, canToggle: false, show: false, toggle: () => {}, money: () => MASK };
}
